import { disconnectAgent, getStatusLabel } from '@/store/gigiChat/Visuals'
import { IShortMessageObject, ISystemAgentVisuals } from '@/types/gigiChat/Chat'
import { IConversation } from '@/types/gigiChat/Conversation'

import ExitLiveAgent from './ExitLiveAgent'

const Container = ({
    item,
    isConnected,
    agentInfo,
}: {
    item: IShortMessageObject | IConversation
    isConnected: boolean
    agentInfo: ISystemAgentVisuals | null
}) => {
    return (
        <ExitLiveAgent
            getStatusLabel={getStatusLabel}
            item={item}
            isConnected={isConnected}
            agentInfo={agentInfo}
            disconnectAgent={disconnectAgent}
        />
    )
}

export default Container
